var _jsxFileName = "/codebuild/output/src2357418120/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/PhoneInput/index.tsx";
import React, { memo, useState } from 'react';
import { IconInfo, IconValidationInvalid, PhoneNumberInput } from '@adc/parallax-component-library';
import InfoBottomSheetModal from './InfoBottomSheetModal';
const PhoneInput = /*#__PURE__*/memo(({
  isInvalid = false,
  label = '',
  errorMessage,
  placeholder = '',
  value,
  onBlur,
  onChangeText,
  disabled,
  testID,
  inputMode,
  onFocus,
  maxLength
}) => {
  const showErrorMessage = isInvalid && errorMessage;
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoBottomSheetModal, {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(PhoneNumberInput, {
    inputMode: inputMode,
    "aria-label": label,
    label: label,
    placeholder: placeholder,
    onFocus: onFocus,
    onBlur: onBlur,
    error: isInvalid,
    supportingText: showErrorMessage ? errorMessage : undefined,
    onChangeText: onChangeText,
    value: value,
    testID: testID,
    disabled: disabled,
    maxLength: maxLength,
    inlineIconConfig: {
      icon: /*#__PURE__*/React.createElement(IconInfo, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 19
        }
      }),
      'aria-label': 'icon',
      onPress: () => {
        setIsOpen(true);
      },
      color: '$interactive.core.enabled',
      disabledColor: '$interactive.core.disabled'
    },
    supportingIconConfig: showErrorMessage ? {
      icon: /*#__PURE__*/React.createElement(IconValidationInvalid, {
        testID: `${testID}-icon`,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 25
        }
      }),
      color: '$support.danger.surfaceOnColorAlt'
    } : undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }));
});
PhoneInput.displayName = 'PhoneInput';
export { PhoneInput };